module.exports = __webpack_public_path__ + "img/close.2820d015.svg";